import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './footer.component';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { XnPipeModule } from './../../pipes/xn-pipe.module';



@NgModule({
  declarations: [
    FooterComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    XnPipeModule,
  ],
  exports: [
    FooterComponent
  ]
})
export class FooterModule { }
